import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { useAppSelector } from "app/redux/hooks";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { DadosTributacao } from "app/types/produto/RespostaTributacao";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Parametro } from "app/types/Parametro";
import { Tributacao } from "./Tributacao";
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto";

export type TributacaoContainerProps = {
    item: IItemOrcamento,
    onRemover: () => void,
    onVoltar: () => void,
    passos: Dict<string, () => void>,
    foraOrcamento: boolean 
}

export const TributacaoContainer = (props: TributacaoContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento);
    const [tributacao, setTributacao] = useState<DadosTributacao>()
    const [parametros, setParametros] = useState<Parametro[]>([])

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map))) 
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)

    const onObterDadosTributacao = async () => {
        try {
            globalMU.blockUI();
            const dadoTributacao = await microuniversoApi.Produto.dadosTributacao({
                IdentificadorOrcamento: orcamento.IdentificadorOrcamento,
                CodigoProduto: props.item.Codigo,
            });
            ("HasErrors" in dadoTributacao) ? (setTributacao(null), globalMU.showWarnMessage('Nenhum registro encontrado.'), onVoltar()) : setTributacao(dadoTributacao)
        } catch (e) {
            onVoltar()
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    // const atualizarParametros = async () => {
    //     setParametros(
    //       await obterParametros({
    //         nomes: [
    //           "CHAVE_MOVIMENTACAO_ORCAMENTO"
    //         ]
    //       })
    //     )
    //   }
    
    // const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    useEffect(() => {
        passosInterno.current.set("Tributação",() => { renderizarComponentReact(<TributacaoContainer {...props} />, "conteudo-pagina", true)  })
        onObterDadosTributacao()
        //atualizarParametros()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                id="TributacaoContainer"
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
            />
            <Tributacao
                dadosTributacao={tributacao}
                produto={ props.item.CodigoProdutoExibicao && props.item.CodigoProdutoExibicao.trimEnd() != ""  ? props.item.CodigoProdutoExibicao.trimEnd() : props.item.CodigoProduto.trimEnd() }
                descricao={props.item.Descricao} />
        </>

    )
}